import React, { Component } from 'react';
import Header from '../../../component/Header';
import Pagination from '../../../component/Pagination';
import {Link} from 'react-router-dom';
import Modal from '../../../component/Modal';

import addIcon from '../../../assets/icon_add.svg';
import editIcon from '../../../assets/icon_edit.svg';
import trashIcon from '../../../assets/icon_trash.svg';
import axios from 'axios';

import { ToastContainer, toast } from 'react-toastify';

import 'react-toastify/dist/ReactToastify.css';
import Layout from '../../Layout';

class Index extends Component {

    constructor(props) {
        super(props);
        this.state = {
            error: null,
            items: [],
            currentPage: null,
            totalPages: null,
            modal: false,
            deleteId: null,
            authorized: true,
            canCRUD: false,
            canView: false
        };
        this.showModal = this.showModal.bind(this);
        this.hideModal = this.hideModal.bind(this);
    }

    componentDidMount() {
        //check if user can view or crud at this section
        this.setState({ canCRUD: ((localStorage.getItem('permissions')).indexOf('can_edit_division') > -1) })
        this.setState({ canView: ((localStorage.getItem('permissions')).indexOf('can_view_division') > -1) })
        axios({
            method: 'GET',
            url: `${process.env.REACT_APP_BASE_API}/api/division`,
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            }
        })
        .then(response => { 
            if(response.data.code !== 401){
                this.setState({ items: response.data.data, currentPage: response.data.meta.currentPage, totalPages: response.data.meta.total });
            }else{
                this.setState({ items: [], currentPage: 1, totalPages: 1, authorized: false })
            }
        })
        .catch(function (error) {
            console.log(error);
        })
    };

    onPageChanged = data => {
        if(this.state.authorized === true){
            const { currentPage } = data;

            axios({
                method: 'GET',
                url: `${process.env.REACT_APP_BASE_API}/api/division?page=${currentPage}`,
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            })
            .then(response => {
                this.setState({ items: response.data.data, currentPage: response.data.meta.currentPage, totalPages: response.data.meta.from });
            })
            .catch(function (error) {
                console.log(error);
            })
        }
    };

    deleteItem = () => {
        axios({
            method: "DELETE",
            url: `${process.env.REACT_APP_BASE_API}/api/division/${this.state.deleteId}`,
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            }
        })
        .then(response => {
            if(response.data.code === 401){
                this.setState({ show: false })
                this.unauthorized();
            }else{
                this.setState({ show: false, deleteId: null, items: this.state.items.filter(item => item.id !== this.state.deleteId) });
                this.success();
            }
        })
        .catch(function (response) {
            console.log(response);
        })
    };

    showModal = (id) => {
        this.setState({ show: true, deleteId: id });
    };

    hideModal = () => {
        this.setState({ show: false, deleteId: null });
    };

    success = () => toast.success("Role has been deleted", {
        position: toast.POSITION.TOP_CENTER
    });

    unauthorized = () => toast.warning("You aren't authorized to do this", {
        position: toast.POSITION.TOP_CENTER
    });

    render() {
        const { items, totalPages } = this.state;

        if (totalPages === null) return null;

        return (
            <Layout>
                <ToastContainer />
                <div className="min-h-screen p-12">
                    <nav className="mb-5 text-xs font-bold text-black" aria-label="Breadcrumb">
                        <ol className="inline-flex p-0 list-none">
                            <li className="flex items-center">
                                <p className="text-gray-500">Division</p>
                            </li>
                        </ol>
                    </nav>
                    <h1 className="mb-5 text-xl font-bold">
                        Division
                    </h1>
                    <div className="py-4 shadow-lg card">
                        {/* only show if user can crud */}
                        {this.state.canCRUD === true &&
                        <div className="px-6 py-3 my-4 bg-gray-200 card-ribbon">
                            <Link to="/admin/division/create" className="inline-flex items-center px-4 py-3 font-semibold tracking-wider text-white bg-red-700 rounded text-md hover:bg-red-900">
                                <img src={addIcon} alt="Add New"></img>
                                <div className="pl-2 ml-2 border-l-2 border-white">New</div>
                            </Link>
                        </div>
                        }
                        <div className='w-full px-4 overflow-x-auto'>
                            {/* only show if user can view */}
                            {this.state.canView === true &&
                            <table className='w-full mx-auto overflow-hidden bg-white divide-y divide-gray-300'>
                                <thead className="bg-gray-50">
                                    <tr className="text-left text-gray-600">
                                        <th width="15%" className="hidden px-6 py-4 text-sm font-semibold uppercase lg:table-cell">
                                            Role
                                        </th>
                                        <th width="60%" className="hidden px-6 py-4 text-sm font-semibold uppercase lg:table-cell">
                                            Content
                                        </th>
                                        <th width="15%" className="hidden px-6 py-4 text-sm font-semibold uppercase lg:table-cell">
                                            Action
                                        </th>
                                    </tr>
                                </thead>
                                <tbody className="divide-y divide-gray-200">
                                    {items.map(item => (
                                    <tr key={item.id} className="flex-row flex-wrap mb-10 lg:table-row lg:flex-row lg:flex-no-wrap lg:mb-0">
                                        <td className="relative block px-6 py-8 lg:py-4 lg:table-cell lg:static">
                                        <span className="absolute top-0 left-0 px-2 py-1 text-xs font-bold uppercase bg-blue-200 lg:hidden">Role</span>
                                            <div className="flex items-center space-x-3">
                                                <div>
                                                    <p className="">
                                                        {item.name}
                                                    </p>
                                                </div>
                                            </div>
                                        </td>
                                        <td className="relative block px-6 py-8 overflow-hidden text-ellipsis max-w-0 whitespace-nowrap lg:py-4 lg:table-cell lg:static">
                                            <span className="absolute top-0 left-0 px-2 py-1 text-xs font-bold uppercase bg-blue-200 lg:hidden">Content</span>
                                            {item.description}
                                        </td>
                                        {/* only show if user can crud */}
                                        {this.state.canCRUD === true &&
                                        <td className="flex px-6 py-8 text-center">
                                            <Link to={`/admin/division/${item.id}`}>
                                                <img src={editIcon} alt="Edit"></img>
                                            </Link>
                                            <button className="ml-2" onClick={ () => {this.showModal(item.id)}}>
                                                <img src={trashIcon}  alt="Remove"></img>
                                            </button>
                                        </td>
                                        }
                                    </tr>
                                    ))}
                                </tbody>
                            </table>
                            }
                        </div>
                        <Modal show={this.state.show} handleClose={this.hideModal}>
                            <div className="text-center">
                                <p className="px-8 text-gray-500">Do you really want to delete this role? This process cannot be undone</p>
                                <div className="p-3 mt-5 space-x-4 text-center md:block">
                                    <button onClick={this.hideModal} className="px-5 py-2 mb-2 text-sm font-medium tracking-wider text-gray-600 bg-white border rounded shadow-sm md:mb-0 hover:bg-gray-100">
                                        Cancel
                                    </button>
                                    <button onClick={this.deleteItem} className="px-5 py-2 mb-2 text-sm font-medium tracking-wider text-white bg-red-700 border border-red-500 rounded shadow-sm md:mb-0 hover:bg-red-900">Delete</button>
                                </div>
                            </div>
                        </Modal>
                        {/* only show if user can view */}
                        {this.state.canView === true &&
                        <div className="m-5">
                            <Pagination totalRecords={totalPages} pageLimit={10} pageNeighbours={1} onPageChanged={this.onPageChanged} />
                        </div>
                        }
                    </div>
                </div>
            </Layout>
        )
    }
}

export default Index;